import { Component } from 'react'

const METHOD_FULL = 'full'

class EmailRouter extends Component {
  /**
   * @param {object} inbox
   * @return {boolean}
   */
  isResponseFull (inbox) {
    const {
      reply: {
        method
      } = {}
    } = inbox

    return (method === METHOD_FULL)
  }
}

export default EmailRouter
